import Vue from 'vue';
import Vuex from 'vuex';

import assessment from './modules/assessment.module';
import attachment from './modules/attachment/attachment.module';
import auth from './modules/auth.module';
import button from './modules/button.module';
import confirm from './modules/confirm.module';
import contest from './modules/contest.module';
import criterion from './modules/criterion.module';
import decision from './modules/decision.module';
import document from './modules/document.module';
import documentIndex from './modules/documentIndex.module';
import documentPack from './modules/documentPack.module';
import documentValue from './modules/documentValue.module';
import event from './modules/event.module';
import financialPlan from './modules/financialPlan.module';
import history from './modules/history.module';
import invoice from './modules/invoice.module';
import layout from './modules/layout.module';
import lock from './modules/lock.module';
import mailTemplate from './modules/mailTemplate.module';
import mdok from './modules/mdok.module';
import media from './modules/media.module';
import menu from './modules/menu.module';
import mobile from './modules/mobile.module';
import module from './modules/module.module';
import notification from './modules/notification.module';
import option from './modules/option.module';
import optionValue from './modules/optionValue.module';
import payment from './modules/payment.module';
import paymentPack from './modules/paymentPack.module';
import person from './modules/person.module';
import procedure from './modules/procedure.module';
import profile from './modules/profile.module';
import role from './modules/role.module';
import schema from './modules/schema.module';
import setting from './modules/setting.module';
import stage from './modules/stage.module';
import statistics from './modules/statistics.module';
import status from './modules/status.module';
import structureNode from './modules/structureNode.module';
import system from './modules/system.module';
import systemMessage from './modules/systemMessage.module';
import template from './modules/template.module';
import view from './modules/view.module';

Vue.use(Vuex);
// Create a new store

const store = new Vuex.Store<any>({
  actions: {},
  getters: {},
  mutations: {},
  state: {},
  modules: {
    assessment,
    attachment,
    auth,
    button,
    confirm,
    contest,
    criterion,
    decision,
    document,
    documentIndex,
    documentPack,
    documentValue,
    event,
    financialPlan,
    history,
    invoice,
    layout,
    lock,
    mailTemplate,
    mdok,
    media,
    menu,
    mobile,
    module,
    notification,
    option,
    optionValue,
    payment,
    paymentPack,
    person,
    procedure,
    profile,
    role,
    schema,
    setting,
    stage,
    statistics,
    status,
    system,
    systemMessage,
    structureNode,
    template,
    view
  }
});

export default store;
